import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AddAddressParams } from "../../../../pending-confirmation/domain/entities/pending-confirmation";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Registers the address the customer gave on the call, so the correction
 *  survives a reload and can be the one the reconfirmed delivery goes to.
 *  Resolves to the new address id. */
export const addAddress = createAsyncThunk<
  string,
  AddAddressParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ADD_ADDRESS, async (params, { extra }) => {
  return await extra.contactCenterRepo.addAddress(params);
});
